// =================================================================
// 				BASIT KONFİGÜRASYON SABİTLERİ
// =================================================================

// Firestore koleksiyon adları — tek doğru kaynak.
// Yeni koleksiyon eklendiğinde önce buraya, sonra firestore.rules'a yansıt.
export const COLLECTIONS = {
    // Çekirdek
    USERS: 'users',
    ORDERS: 'orders',
    CUSTOMERS: 'customers',
    PRODUCTS: 'products',
    CATEGORIES: 'categories',
    // Operasyon / muhasebe
    LEDGER_ENTRIES: 'ledgerEntries',
    EXPENSE_CATEGORIES: 'expenseCategories',
    EXPENSE_RECORDS: 'expenseRecords',
    // Pazarlama / sadakat
    SUBSCRIPTIONS: 'subscriptions',
    REFERRALS: 'referrals',
    REFERRAL_CODES: 'referralCodes',
    NOTIFICATIONS: 'notifications',
    // Audit & log
    AUDIT_LOGS: 'auditLogs',
    // Dashboard widget verileri
    DASHBOARD_NOTES: 'dashboardNotes',
    DASHBOARD_TODOS: 'dashboardTodos',
    DASHBOARD_TRANSACTIONS: 'dashboardTransactions',
    DASHBOARD_TRASH: 'dashboardTrash',
    // Günlük operasyon
    DAILY_NOTES: 'dailyNotes',
    DAILY_REPORTS: 'dailyReports',
    // Lojistik / ayar
    DISTRIBUTORS: 'distributors',
    TIME_SLOT_SETTINGS: 'timeSlotSettings',
    CONFIG: 'config',
} as const;

export type CollectionName = typeof COLLECTIONS[keyof typeof COLLECTIONS];

export const APP_CONFIG = {
    APP_NAME: 'Asil Ticaret',
    COLLECTIONS,
};

export const STORAGE_KEYS = {
    CART_ITEMS: 'asil_cart_items'
};

// Kargo için basit sabitler
export const SHIPPING = {
    FREE_THRESHOLD: 100,
    DEFAULT_COST: 25,
};

// Teslimat zamanları ve planlı teslimat indirimleri
export const DELIVERY = {
    SLOTS: [
    '10:00-12:00',
    '12:00-14:00',
    '14:00-16:00',
    '16:00-18:00',
    ],
    DISCOUNTS: {
        DAY_1: 0.05, // Yarın %5
        DAY_2: 0.10, // 2 gün sonra %10
    },
};

// Raporlar sayfası için basit PIN (isteğe bağlı .env ile özelleştirilebilir)
export const REPORTS_PIN: string = (process.env.REACT_APP_REPORTS_PIN as string) || '2468';

export default APP_CONFIG;
